import axios from "axios";
import { BASE_URL } from "../Host";

export const GetAllForm = async (adminToken, role_id) => {
  try {
    const res = await axios.get(BASE_URL + "form/getAllForm", {
      headers: {
        "x-access-token": `${adminToken}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return res;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

//get products byid
export const GetFormById = async (id) => {
  return await axios.get(BASE_URL + `form/findFormById/${id}`);
};